import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from "react-bootstrap";
import { getDetailsById } from '../utils/axios';

const ModalForm = ({
    show,
    onClose,
    module,
    id,
    title,
    fields,
    onSubmit,
    description,
    buttonText,
    fileType,
}) => {
    const [formData, setFormData] = useState(
        fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {})
    );

    useEffect(() => {
        const getDetails = async () => {
            if (id) {
                await getDetailsById(module, id, setFormData);
            }
            else{
                setFormData({})
            }
        };

        getDetails();
    }, [module, id]);

    const handleFileChange = (e) => {
        setFormData({ ...formData, file: e.target.files[0] });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        await onSubmit(formData);
        setFormData({});
        onClose();

    };

    return (
        <Modal show={show} onHide={onClose} >
            <Modal.Header closeButton>
                <Modal.Title className="text-capitalize">{title}</Modal.Title>
            </Modal.Header>
            {description && <p className="px-3 py-1 align-content-center">{description}</p>}
            <Modal.Body>
                <Form onSubmit={handleFormSubmit}>
                    {fields.map((field) => (
                        <Form.Group key={field.name} className="mb-3">
                            <Form.Label>{field.label}</Form.Label>
                            {field.type === 'file' ? (
                                <Form.Control
                                    type={field.type}
                                    onChange={handleFileChange}
                                    required={field.required}
                                    accept={fileType}
                                />
                            ) : field.type === 'select' ? (
                                <Form.Select
                                    name={field.name}
                                    value={formData[field.name] || ''}
                                    onChange={handleChange}
                                    required={field.required}
                                >
                                    {field.options?.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            ) : field.type === 'textarea' ? (
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name={field.name}
                                    value={formData[field.name] || ''}
                                    onChange={handleChange}
                                    required={field.required}
                                    placeholder={field.placeholder}
                                />
                            ) : (
                                <Form.Control
                                    id={field.name}
                                    type={field.type}
                                    name={field.name}
                                    value={formData[field.name] || ''}
                                    onChange={handleChange}
                                    required={field.required}
                                    placeholder={field.placeholder}
                                    pattern={field.pattern}
                                />)}

                        </Form.Group>
                    ))}
                    <div className="d-flex justify-content-end">
                        <Button variant="danger" className=" rounded-3  me-2" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="rounded-3" type="submit">
                            {buttonText}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ModalForm;